// Import translation
import i18n from 'i18next';

export const vod = {
	title: i18n.t('common:products_tabs.vod'),
	apiUrl: '/vod/newList?',
	type: 'vod'
};

export const channel = {
	title: i18n.t('common:products_tabs.live'),
	apiUrl: '/products/channels?',
	type: 'channel'
};

export const section_assigned = {
	title: i18n.t('common:products_tabs.sections'),
	apiUrl: '/section/list?',
	type: 'sections'
};

export const banners = {
	title: i18n.t('common:products_tabs.banners'),
	apiUrl: '/section/banners/list?',
	type: 'banners'
};

export const providers = {
	title: i18n.t('common:products_tabs.provider'),
	apiUrl: '/vod/listProviders?',
	type: 'provider'
};

export const provisioning = {
	title: i18n.t('common:products_tabs.provisioning'),
	apiUrl: 'packet/list?type=provision&',
	type: 'provisioning'
};

export const collections = {
	title: i18n.t('common:products_tabs.collections'),
	apiUrl: 'packet/list?type=collection&',
	type: 'collections'
};

export const packets = {
	title: i18n.t('common:products_tabs.main'),
	apiUrl: 'packet/list?type=main&',
	type: 'main'
};
